import { render, staticRenderFns } from "./product_management_home.vue?vue&type=template&id=66bf2a4a&scoped=true"
import script from "./product_management_home.vue?vue&type=script&lang=js"
export * from "./product_management_home.vue?vue&type=script&lang=js"
import style0 from "./product_management_home.vue?vue&type=style&index=0&id=66bf2a4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf2a4a",
  null
  
)

export default component.exports